import { render } from "./GameStandings.vue?vue&type=template&id=30d8f15c&scoped=true"
import script from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"
export * from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"

import "./GameStandings.vue?vue&type=style&index=0&id=30d8f15c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d8f15c"]])

export default __exports__